import { render } from "./PopupObjectsConfiguration.vue?vue&type=template&id=57d0b5d3"
import script from "./PopupObjectsConfiguration.vue?vue&type=script&lang=js"
export * from "./PopupObjectsConfiguration.vue?vue&type=script&lang=js"

import "./PopupObjectsConfiguration.vue?vue&type=style&index=0&id=57d0b5d3&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__